import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRealEstates } from '../slices/realEstateSlice';
import { getRealEstateTypes } from '../slices/realEstateTypeSlice';
import Footer from '../Footer';
import Carousel from '../components/home/Carousel';
import SalesSection from '../components/home/SalesSection';
import ContactSection from '../components/home/ContactSection';
import AboutSection from '../components/home/AboutSection';
import Loader from '../utilities/Loader';
import NavigationBar from '../NavigationBar';
import WhatsAppButton from '../utilities/WhatsAppButton';
import { useAuth0 } from '@auth0/auth0-react';

export default function HomePage() {
  const { isLoading } = useAuth0();
  const realEstates = useSelector((state) => state.realEstates.data);
  const realEstatesStatus = useSelector((state) => state.realEstates.status);
  const realEstateTypes = useSelector((state) => state.realEstateTypes.data);
  const realEstateTypesStatus = useSelector(
    (state) => state.realEstateTypes.status
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (realEstatesStatus === 'idle' || realEstateTypesStatus === 'idle') {
      dispatch(getRealEstates());
      dispatch(getRealEstateTypes());
    }
  }, [dispatch, realEstatesStatus, realEstateTypesStatus]);

  // Función para seleccionar hasta 5 inmuebles aleatorios
  const getRandomRealEstates = (realEstates) => {
    const maxRealEstates = 5;
    // Clonamos el array antes de modificarlo
    const shuffled = [...realEstates].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, Math.min(maxRealEstates, realEstates.length));
  };

  // Solo pasamos las inmuebles si ya tenemos éxito en la carga
  const randomRealEstates =
    realEstatesStatus === 'succeeded' ? getRandomRealEstates(realEstates) : [];

  return (
    <>
      {realEstatesStatus !== 'succeeded' ||
      realEstateTypesStatus !== 'succeeded' ||
      isLoading ? (
        <Loader />
      ) : (
        <>
          <NavigationBar />
          <Carousel
            realEstates={randomRealEstates}
            realEstateTypes={realEstateTypes}
          />
          <SalesSection realEstateTypes={realEstateTypes} />
          <AboutSection />
          <ContactSection />
          <WhatsAppButton />
          <Footer />
        </>
      )}
    </>
  );
}
